import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import SingleComputer from '../Button/ButtonCard/SingleComputer';
import './Card.css';
import BntMoreUltraScale from '../PopUps/BntMoreUltraScale';
import { Box, Typography } from '@mui/material';
/**
 * UltraScaleComputer component renders a card with UltraScale computer information.
 * 
 * @component
 * @param {Object} props - The properties object.
 * @param {Function} props.handleRedundantUltraScale - The callback function to handle redundant UltraScale computer.
 * @param {Function} props.handleNominalUltraScale - The callback function to handle nominal UltraScale computer.
 */
const UltraScaleComputer = ({
  /**
   * The callback function to handle redundant UltraScale computer.
   */
  module,
  handleDecrement,
  /**
   * The callback function to handle nominal UltraScale computer.
   */
  handleNominalUltraScale, reset
}) => {
  const [open, setOpen] = useState(false);



  /**
   * Handles the click event to open the UltraScale computer popup.
   */
  const handleClickOpen = () => {
    setOpen(true);
  };

  return (
    <Card variant="outlined" sx={{
      /**
       * Custom styles for the card container
       */
      width: '430px',
      height: '200px',
      border: 'none',
      boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'
    }}>
      <CardContent>


        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 2
          }}
        >
          <Typography
            variant="h6"
            component="h3"
            sx={{
              fontFamily: 'Open Sans',
              m: 0,
             
              fontWeight: 'bold',
            }}
          >
            UltraScale + Computer                    </Typography>

          <BntMoreUltraScale size="small" onClick={handleClickOpen}></BntMoreUltraScale>
        </Box>


        <div>
          <div style={{
            /**
             * Custom styles for the button container
             */
            marginBottom: '1%',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex'
          }}>
            <SingleComputer onClick={() => handleNominalUltraScale(module)} handleSingleComputerDecrement={() => handleDecrement(module)} reset={reset} />
          </div>

        </div>
        <p style={{
          /**
           * Custom styles for the paragraph
           */
          fontFamily: 'Open Sans',
          fontSize: '12px',
          marginRight: '16%'
        }}>
High-Performance Multi-Core Processing Module for 
satellite avionics based in a ADHA-compliant 3U form factor.
     </p>
        <div style={{
          /**
           * Custom styles for the button container
           */
          display: 'flex',
          justifyContent: 'flex-end'
        }}>

        </div>
      </CardContent>
    </Card>
  );
};

/**
 * Exports the UltraScaleComputer component as the default export.
 */
export default UltraScaleComputer;